export const GROUP_REGISTRY_LOCK_NAME = "workspace-global-groups-v3";

export class GroupRegistryUnavailableError extends Error {
  constructor() {
    super("The global group registry requires the Web Locks API");
    this.name = "GroupRegistryUnavailableError";
  }
}

export interface GroupRegistryLock {
  run: <T>(callback: () => T | Promise<T>) => Promise<T>;
}

interface CreateGroupRegistryLockOptions {
  navigatorLocks?: LockManager | null;
  name?: string;
}

export const createGroupRegistryLock = ({
  navigatorLocks = navigator.locks,
  name = GROUP_REGISTRY_LOCK_NAME,
}: CreateGroupRegistryLockOptions = {}): GroupRegistryLock => {
  if (!navigatorLocks) {
    throw new GroupRegistryUnavailableError();
  }
  return {
    run: async <T>(callback: () => T | Promise<T>): Promise<T> =>
      await navigatorLocks.request(name, callback),
  };
};
